import tw, { styled } from 'twin.macro';
import { Tooltip } from 'react-tooltip';

// NOTE: Force reset margin on figure to avoid unwanted spacing, to delete when implementing the new design for CodeSnippet file path
export const StyledFigure = styled.figure`
  ${tw`relative`}
  ${tw`!my-0`}
`;

export const StyledCodeSnippet = styled.code<{ hasHorizontalScrollbar: boolean }>`
  ${({ hasHorizontalScrollbar }) => hasHorizontalScrollbar && tw`overflow-x-scroll whitespace-pre`}
`;

export const StyledDescription = styled.figcaption`
  ${tw`pt-1`}
  & a {
    ${tw`underline`}
  }
`;

export const StyledImage = styled.svg`
  ${tw`w-[16px] h-[16px]`}
  ${tw`text-neutrals-n1`}
`;

export const StyledButton = styled.button`
  ${tw`absolute`}
  ${tw`right-2 top-2`}
`;

export const StyledTooltip = styled(Tooltip)``;
